<template>
  <div class="container">
    <div class="card" v-if="msg_pergunta">
      <div class="icon-info">📅</div>      
      <h1>Confirmação de {{msgTipo1}}</h1>
      <div class="dados-empresa">
        <h2>{{clinica_nome}}</h2>   
        <h3>{{clinica_telefone}}</h3>     
        <h3>{{clinica_endereco}}</h3>      
      </div>

      <p class="mensagem">
        Olá <strong>{{ nome }}</strong>, {{msgTipo2}} está marcada para o dia 
        <strong>{{ data }}</strong> às <strong>{{ horario }}</strong> com o médico 
        <strong>{{ medico }}</strong>.<br><br>
        Deseja confirmar o agendamento?
      </p>

      <div class="botoes">
        <button class="btn btn-confirmar" @click="responder('CONFIRMAR')">
          Confirmar
        </button>

        <button class="btn btn-cancelar" @click="responder('CANCELAR')">
          Cancelar
        </button>
      </div>
    </div>
    <div class="card" v-if="msg_confirmado">
      <div class="icon-info">✔</div>      
      <h1>{{msgTipo1}} confirmado</h1>
      <div class="dados-empresa">
        <h2>{{clinica_nome}}</h2>   
        <h3>{{clinica_telefone}}</h3>   
        <h3>{{clinica_endereco}}</h3>        
      </div>

      <p class="mensagem">
        Olá <strong>{{ nome }}</strong>, {{msgTipo2}} no dia 
        <strong>{{ data }}</strong> às <strong>{{ horario }}</strong> com o médico 
        <strong>{{ medico }}</strong> esta <strong>confirmada</strong>.
        
      </p>
    </div>
    <div class="card" v-if="msg_cancelado">
      <div class="icon-info">❌</div>      
      <h1>{{msgTipo1}} cancelada</h1>
      <div class="dados-empresa">
        <h2>{{clinica_nome}}</h2>   
        <h3>{{clinica_telefone}}</h3>        
        <h3>{{clinica_endereco}}</h3>        
      </div>

      <p class="mensagem">
        Olá <strong>{{ nome }}</strong>, {{msgTipo2}} no dia 
        <strong>{{ data }}</strong> às <strong>{{ horario }}</strong> com o médico 
        <strong>{{ medico }}</strong> esta <strong>cancelada</strong>.<br>
        Qualquer duvida entre em contato através do telefone.        
      </p>
    </div>    
    <div class="card" v-if="msg_nao_encontrado">
      <div class="icon-info">📅</div>            
      <h1>Agendamento não encontrato</h1>
    </div>
  </div>  
</template>

<script>
import api from '../services/api.js';
export default {
  name: "ConfirmaConsulta",
  data() {
    return {
      id: null,
      nome: "",
      data: "",
      horario: "",
      medico: "",
      clinica_nome: "",
      clinica_telefone: "",
      clinica_endereco: "",
      msg_pergunta: true,
      msg_confirmado: false,
      msg_cancelado: false,
      msg_nao_encontrado: false,
      msgTipo1:'Consulta',
      msgTipo2:'sua consulta',
    };
  },
  mounted() {
    document.title = "Confirmação de Consulta";
    this.carregarDados();
  },  
  methods: {
    async carregarDados() {
      try {

        this.id = this.$route.params.id;


        if (!this.id) {
          alert("ID não informado");
          return;
        }
  

        const response = await api.get(`agenda/${this.id}`);

        console.log(response);

        const dados = response.data;
        if (response.status==200) {


            this.nome = dados.msg_nome;
            this.data = dados.msg_data;
            this.horario = dados.msg_hora;
            this.medico = dados.msg_nome_medico;
            this.clinica_nome = dados.msg_empresa;
            this.clinica_telefone = dados.msg_empresa_telefone;  
            this.clinica_endereco = dados.msg_empresa_endereco;  

            this.msgTipo1 = 'Consulta';
            this.msgTipo2 = 'sua consulta';   
            if (dados.exame_consulta=='E'){
              this.msgTipo1 = 'Exame';
              this.msgTipo2 = 'seu exame';   
            }        

            if (dados.msg_resposta=='CONFIRMADO'){
                this.msg_pergunta = false;
                this.msg_confirmado = true;              
            }
            else
            if (dados.msg_resposta=='CANCELADO'){
                this.msg_pergunta = false;
                this.msg_cancelado = true;           
            }

        }  
        else
        if (response.status==201) {
            if (response.data=='nao_encontrado'){
                this.msg_pergunta = false;
                this.msg_nao_encontrado = true;
            }         
        }            

      } catch (error) {
        console.error(error);
        alert("Erro ao carregar dados do agendamento");
      } finally {
        
      }
    },    
    async responder(resp) {
        try
        {
            const dados = {codigo: this.id, resposta: resp}
            const response = await api.post('responder',dados);
            if (response.status==200) {
                if (resp=='CONFIRMAR'){
                    this.msg_pergunta = false;
                    this.msg_confirmado = true;              
                }
                else
                if (resp=='CANCELAR'){
                    this.msg_pergunta = false;
                    this.msg_cancelado = true;           
                }
            }
            else
            if (response.status==201) {
                if (response.data=='nao_encontrado')
                    alert('Agendamento não encontrado')
                else
                if (response.data=='possui_resposta')
                    alert('Este agendamento já possui resposta');                
            }
        } catch (error) {
            console.error(error);
            alert("Erro ao responder");
        }

    }
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: Arial, sans-serif;
}

.container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: #f4f6f9;
  padding: 16px;
}

.card {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  width: 100%;
  max-width: 420px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  text-align: center;
}

.icon-info {
  width: 70px;
  height: 70px;
  background: #007bff;
  color: white;
  font-size: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
}

h2{
  font-size: 18px;
  margin-bottom: 0;
  color: #333;
}

h3{
  font-size: 15px;
  font-weight: 0;
  margin-bottom: 0;
  color: #333;
}

h1 {
  font-size: 22px;

  color: #333;
}

.mensagem {
  font-size: 15px;
  color: #555;
  margin-top: 10px;
  margin-bottom: 24px;
  line-height: 1.5;
}

.botoes {
  display: flex;
  gap: 10px;
}

/* Botões */
.btn {
  flex: 1;
  padding: 12px;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  cursor: pointer;
  transition: 0.3s;
}

/* Confirmar */
.btn-confirmar {
  background: #28a745;
  color: white;
}

.btn-confirmar:hover {
  background: #218838;
}

/* Cancelar */
.btn-cancelar {
  background: #dc3545;
  color: white;
}

.btn-cancelar:hover {
  background: #c82333;
}

/* Responsivo */
@media (max-width: 400px) {
  .botoes {
    flex-direction: column;
  }
}
</style>